<template>
    <multiselect
        v-model="valueLocal"
        placeholder="Seleccionar temporada"
        label="nombre"
        track-by="id"
        style="z-index: 999;"
        :options="listas"
        :allowEmpty="false"
        :multiple="multiple"
        @input="$emit('input', valueLocal)"
    />
</template>

<script>
    export default {
        props: {
            value: {
                required: true
            },
            multiple: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                valueLocal: this.multiple ? [ ...this.value ] : { ...this.value }
            };
        },
        watch: {
            value: {
                handler(newVal) {
                    this.valueLocal = this.multiple ? [ ...newVal ] : { ...newVal };
                },
                deep: true
            }
        },
        computed: {
            listas() {
                return this.$store.getters.getListas;
            }
        }
    }
</script>